<template>
  <header class="small-header">
    <div class="header-top">
      <i class="iconfont iconfanhui back" @click.stop="goback"></i>
    </div>
    <div class="header-title">
      <p class="title">{{ chname }}</p>
      <p class="focus-text">{{ focusText }}</p>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    chname: {
      type: String,
      default: "",
    },
    conclusionLevel: {
      // 风险等级
      type: String,
      default: "",
    },
  },
  computed: {
    focusText() {
      // 疾病描述样式
      const level = this.conclusionLevel;
      switch (level) {
        case "高风险":
          return "需要重点关注";
        case "较高风险":
          return "需要关注";
        case "一般风险":
          return "可以适当关注";
        case "较低风险":
          return "可适当了解";
        case "低分险":
          return "可以了解";
        default:
          return "可以了解";
      }
    },
  },
  methods: {
    goback() {
      // 获取来源地址
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/functions";
.small-header {
  width: 100%;
  background: #00a0e8 linear-gradient(160deg, #34c2e0 0, #44a2cf pxToRem(266px));
  height: pxToRem(266px);
  padding: 0 pxToRem(25px);
  .back {
    z-index: 999;
    padding-top: pxToRem(10px);
    color: #fff;
  }
  .header-top {
    display: flex;
    min-height: pxToRem(120px);
    padding-top: pxToRem(15px);
  }
  .header-title {
    color: #fff;
    .title {
      display: inline-block;
      font-size: 0.22rem;
      letter-spacing: 1px;
    }
    .focus-text{
      padding-top: .15rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/smallGlobal/GlobalHeader.vue